//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Mechatronics.js";
import "../no/Builder.js";
import "../Mechatronics/Mechatronics.SelectRigidBody.js";
import "../no/SelectNXObjectList.js";
import "../no/SelectNXObject.js";
import "../Mechatronics/Mechatronics.SelectCollisionSensor.js";
import "../Mechatronics/Mechatronics.SelectSignal.js";
import "../no/Expression.js";
import "../no/DisplayableObject.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"ActionMode",1,0],[0,"DefineTracerStyle",1,0],[1,"FromRigidBody",0,"Mechatronics.SelectRigidBody",0],[1,"MarkerPoints",0,"SelectNXObjectList",0],[0,"Name",1,0],[0,"SelectPoint",1,"Point",0],[1,"SelectRefBody",0,"SelectNXObject",0],[1,"SelectSensor",0,"Mechatronics.SelectCollisionSensor",0],[1,"SelectSignal",0,"Mechatronics.SelectSignal",0],[1,"Selection",0,"Mechatronics.SelectRigidBody",0],[0,"ShowInSimulation",1,0],[1,"TargetRigidBody",0,"Mechatronics.SelectRigidBody",0],[1,"TraceRateSetting",0,"Expression",0],[0,"TracerColor",1,0],[0,"TracerFont",1,0],[0,"TracerWidth",1,0],[0,"Type",1,0]],[[["points"],"SetMarkerPoints",{},1,0]],[]];
SPLM.Mechatronics.TracerBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Mechatronics.TracerBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Mechatronics.TracerBuilder.Types = Object.freeze({
    "Curve" : "Curve", "Marker" : "Marker"});

SPLM.Mechatronics.TracerBuilder.ActionModeTypes = Object.freeze({
    "Sensor" : "Sensor", "Signal" : "Signal", "UserDefined" : "UserDefined"});

export default SPLM;